import * as React from "react";
import { withStores } from "stores";
import { PageHeadingProps } from "../typings";
import { UitkHeading } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";

const PageHeadingWizard = (props: PageHeadingProps) => {
  const { formatText } = useLocalization();
  const {
    compositionStore: { pageHeading },
    context,
  } = props;
  const headingSize = context.deviceInformation && context.deviceInformation.mobile ? 800 : 900;

  if (!pageHeading) {
    return null;
  }

  if (props.flexComponent.model.view === "hidden") {
    return <h2 className="sr-only">{formatText("wizard.a11y.header")}</h2>;
  }

  return (
    <div className="uitk-cell all-t-padding-one all-b-padding-four">
      <UitkHeading level={1} size={headingSize}>
        {pageHeading}
      </UitkHeading>
    </div>
  );
};

export default withStores("compositionStore")(PageHeadingWizard);
